var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"dropdown-item",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.logout.apply(null, arguments)}}},[_c('i',{staticClass:"tim-icons icon-button-power"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('auth.log-out')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }